export const SOCKET_EVENTS = {
  ALERT_NEW: 'alert:new',
  IMPORT_PROGRESS: 'import:progress',
  IMPORT_DONE: 'import:done',
  CATEGORIZATION_DONE: 'categorization:done',
  INSIGHT_NEW: 'insight:new',
} as const;

export const APP_LOCALE = 'fr-CH';
export const APP_CURRENCY = 'CHF';
export const APP_TIMEZONE = 'Europe/Zurich';
